export const METER_READING_MODE_DIRECT_READING = 'direct_reading';
export const METER_READING_MODE_CHANGE_FROM_BASELINE = 'change_from_baseline';
export const METER_READING_MODE_COMPARE_TO_TARGET = 'compare_to_target';

export const METER_READING_MODE_OPTIONS = [
	{ label: 'Direct Reading', value: METER_READING_MODE_DIRECT_READING },
	{ label: 'Change from Baseline', value: METER_READING_MODE_CHANGE_FROM_BASELINE },
	{ label: 'Compare to Target', value: METER_READING_MODE_COMPARE_TO_TARGET },
];
